import React, { Fragment, useEffect, useState, useMemo } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, Card, CardBody, CardFooter, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import ReactTableGeneric from "Components/ReactTableGeneric";
import Loader from "react-loaders";
import { toast } from "react-toastify";
import { Formik } from "formik";
import ReactTableGenericForUsers from "Components/ReactTableGenericForUsers";
import { debounce } from "helperFunctions";
import { useCommunityContractList, useSaveSms, useSmsHistory, useUsersSmsInfo } from "Api/Coordinator/Beheer/SendSMS";


const SendSMS = () => {
    let formikSubmit;
    const [pageSizeCount, setPageSizeCount] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchValue, setSearchValue] = useState("");
    const [search, setSearch] = useState("");
    const [filterData, setFilterData] = useState({
        community: '',
        user: '',
        contractType: '',
    });
    const [contractList, setContractList] = useState([]);
    const [remainingChars, setRemainingChars] = useState(1377);
    const [description, setDescription] = useState('');
    const [textLimit, setTextLimit] = useState(0);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const { trigger: saveSms, isMutating } = useSaveSms();

    const {
        data: communityResponse
    } = useCommunityContractList();

    const communities = communityResponse?.data || [];

    useEffect(() => {

        if (communities.length > 0 && !filterData.community) {
            setFilterData({
                community: communities[0].iCommunityId,
                user: "",
                contractType: ""
            });
        }
    }, [communities]);

    useEffect(() => {

        if (communities?.length > 0 && filterData.community) {
            const data = communities.find(item => String(filterData.community) === String(item.iCommunityId));
            if (data) {
                setContractList(data?.contracttypes)
            }
        }
    }, [filterData.community, communities]);

    const {
        data: smsHistoryResponse,
        isLoading: historyLoader
    } = useSmsHistory(filterData.community);

    const {
        trigger: getUsersSmsInfo,
        data: usersResponse,
        isMutating: usersLoader
    } = useUsersSmsInfo();

    const smsHistoryData =
        smsHistoryResponse?.data?.data || [];

    const totalCountHistory = smsHistoryResponse?.data.totalCount;

    const usersData =
        usersResponse?.data?.infoList || [];

    const totalPageCount =
        usersResponse?.data?.count || 0;

    const totalUsers = usersResponse?.data?.totalCount;

    const handleInputChange = useMemo(
        () =>
            debounce((val) => {
                setPageNumber(1);
                setSearch(val);
            }, 500),
        [],
    );

    const filterList = (val) => {
        handleInputChange(val);
    };

    useEffect(() => {
        if (!filterData.community) return;

        getUsersSmsInfo({
            data: {
                selUser: filterData.user,
                pageNumber,
                pageSize: pageSizeCount,
                iCommunityId: filterData.community,
                iContractType: filterData.contractType,
                search: search,
            }
        });
    }, [
        filterData.community,
        filterData.user,
        filterData.contractType,
        pageNumber,
        pageSizeCount,
        search,
    ]);

    const smsHistoryCol = React.useMemo(
        () => [
            {
                header: () => 'Datum',
                accessorKey: 'Datum',
                size: 70,
                cell: (value) => {
                    return <><div>
                        {value.row.original.date}
                    </div>
                    </>
                }
            },
            {
                header: () => 'Bericht',
                accessorKey: 'message',
                size: 280,
            },
            {
                header: () => 'Naam verzender',
                accessorKey: 'name',
                size: 100,
            },
            {
                header: () => 'Mobiele ontvanger',
                accessorKey: 'mobile',
                size: 70,
            },
            {
                header: () => 'Status',
                accessorKey: 'status',
                size: 70,
            }
        ],
        [smsHistoryData]
    );

    const smsCols = React.useMemo(
        () => [
            {
                header: () => 'Naam',
                accessorKey: 'name',
            },
            {
                header: () => 'Plaats',
                accessorKey: 'vCity',
            },
            {
                header: () => 'Mobiel',
                accessorKey: 'iMobileNumber',
            },
            {
                header: () => (
                    <div onClick={(e) => e.stopPropagation()}>
                        <Input
                            type="checkbox"
                            className="col-md-12 me-1"
                            checked={selectAllChecked}
                            onChange={(e) => selectAll(e.target.checked)}
                        />
                    </div>
                ),
                accessorKey: 'rows',
                cell: (value) => {
                    return (
                        <Input
                            type="checkbox"
                            className="col-md-12"
                            checked={selectedUsers?.includes(value.row.original.iAdminId)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    selectedUsersHandler(value.row.original.iAdminId, 'ADD');
                                } else {
                                    selectedUsersHandler(value.row.original.iAdminId, 'REMOVE');
                                }
                            }}
                        />
                    );
                },
            },
        ],
        [usersData, selectAllChecked, selectedUsers]
    );

    const handleOrgSubmit = () => {
        if (selectedUsers?.length === 0) {
            toast.error("Selecteer minimaal één gebruiker.");
            return;
        }
        setBtnDisabled(true);
        const payload = {
            iAdminIds: selectedUsers.join(","),
            message: description,
            iCommunityId: filterData.community
        };

        saveSms({
            data: payload
        }).then((response) => {
            if (response.status) {
                toast.success("Sms succesvol verzonden");
                setSelectedUsers([]);
                setBtnDisabled(false);
            } else {
                toast.error("Kan geen sms versturen.");
                setBtnDisabled(false);
            }
        }).catch((err) => console.error(err));
    }

    const paginate = (val) => {
        setPageNumber(val);
    }
 
    const userTablePageSize = (val) => {
        setPageNumber(1);
        setPageSizeCount(val);
    }

    const filterHandler = (type, value) => {
        setFilterData((prev) => {
            return { ...prev, [type]: value }
        })
    }
    const handleTextareaChange = (e) => {
        const textLength = e.target.value.length;
        const remaining = 1377 - textLength;

        if (remaining >= 0) {
            setDescription(e.target.value);
            setRemainingChars(remaining);
            calculateSmsLimit(textLength);
        } else {

            const truncatedText = e.target.value.substring(0, 1377);
            setDescription(truncatedText);
            setRemainingChars(0);
            calculateSmsLimit(1377);
        }
    };

    const calculateSmsLimit = (textLength) => {
        const smsCount = Math.ceil(textLength / 160);
        setTextLimit(smsCount);
    };

    function selectAll(checked) {
        setSelectAllChecked(checked);
        if (checked) {
            const usersAdminIds = usersData.map((item) => item.iAdminId);
            selectedUsersHandler(usersAdminIds, 'ADD_ALL');
        } else {
            selectedUsersHandler([], 'REMOVE_ALL');
        }
    }

    function selectedUsersHandler(userAdminIds, type = "") {
        setSelectedUsers((prevSelectedUsers) => {
            switch (type) {
                case "ADD_ALL":
                    return userAdminIds;
                case "REMOVE_ALL":
                    return [];
                case "ADD":
                    return [...prevSelectedUsers, userAdminIds];
                case "REMOVE":
                    setSelectAllChecked(false);
                    return prevSelectedUsers.filter(userId => userId !== userAdminIds);
                default:
                    return prevSelectedUsers;
            }
        });
    }

    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <Row className="mb-5">
                    <Col sm={12}>
                        <div className="row">
                            <div className="col-lg-6 ">
                                <Card className="main-card mb-3" style={{ height: '95%' }}>
                                    <CardBody className="p-3">
                                        <Formik
                                            initialValues={{ description: '' }}
                                            validate={(values) => {
                                                const errors = {};
                                                if (!values.description) {
                                                    errors.description = 'Beschrijving is verplicht.';
                                                }
                                                return errors;
                                            }}
                                            onSubmit={handleOrgSubmit}
                                        >
                                            {({ handleSubmit, handleBlur, handleChange, values, errors, touched, submitForm }) => {
                                                formikSubmit = submitForm;
                                                return <Form onSubmit={handleSubmit}>
                                                    <FormGroup>
                                                        <Input
                                                            name="description"
                                                            type="textarea"
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                handleTextareaChange(e);
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.description}
                                                            maxLength={1377}
                                                            rows="10"
                                                        />
                                                        {errors.description && touched.description && (
                                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                                {errors.description}
                                                            </div>
                                                        )}
                                                    </FormGroup>
                                                    <FormGroup className="form-element d-flex justify-content-between">
                                                        <Label for="remainingChars">Aantal tekens resterend:</Label>
                                                        <div>
                                                            <Input
                                                                name="remainingChars"
                                                                type="text"
                                                                value={remainingChars}
                                                                disabled
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup className="form-element d-flex justify-content-between">
                                                        <Label for="textLimit">Aantal sms per gebruiker:</Label>
                                                        <div>
                                                            <Input
                                                                id="txtLimit"
                                                                name="textLimit"
                                                                type="text"
                                                                value={textLimit}
                                                                disabled
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                    <FormGroup className=" form-element d-flex justify-content-between mb-4">
                                                        <Label for="selectedUsers">Aantal geselecteerde gebruikers:</Label>
                                                        <div>
                                                            <Input
                                                                id="selectedUsers"
                                                                name="selectedUsers"
                                                                type="text"
                                                                value={selectedUsers.length}
                                                                disabled
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </Form>
                                            }}
                                        </Formik>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="col-lg-6">
                                <Card className="main-card mb-3" style={{ height: '95%' }}>
                                    <CardBody className="p-3">
                                        <>
                                            <ReactTableGenericForUsers
                                                data={usersData}
                                                tableClassName="mb-0 table table-sm table-hover tb-req"
                                                userTablePageSize={userTablePageSize}
                                                totalPageCount={totalPageCount}
                                                filterList={filterList}
                                                pageNumber={pageNumber}
                                                pageSizeCount={pageSizeCount}
                                                showLoader={usersLoader}
                                                setPageNumber={setPageNumber}
                                                paginate={paginate}
                                                columns={smsCols}
                                                filters={{ search: true, pagination: true, sorting: true }}
                                                rowCount={10}
                                                count={totalUsers}
                                            />
                                        </>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <div className="row">
                            <div className="col">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        {historyLoader ? <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} /> : <ReactTableGeneric
                                            data={smsHistoryData || []}
                                            columns={smsHistoryCol}
                                            tableClassName="mb-0 table table-borderless table-sm table-hover tb-api tb-links"
                                            rowCount={20}
                                            filters={{ search: true, pagination: true, sorting: false }}
                                            count={totalCountHistory}

                                        />}
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </Col>
                </Row>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex justify-content-between gap-3 mr-4">
                        <div className="d-flex gap-3">
                            <div>
                                <select className={`form-select`} value={filterData.community} onChange={(e) => {
                                    filterHandler('community', e.target.value);
                                    filterHandler('contractType', '')
                                }}>
                                    <option value={''}>Alle besturen</option>
                                    {communities?.map(item => {
                                        return <option value={item.iCommunityId}>{item.vCommunityName}</option>
                                    })}
                                </select>
                            </div>
                            <div>
                                <select className={`form-select`} value={filterData.user} onChange={(e) => { filterHandler('user', e.target.value) }}>
                                    <option value={''}>Alle gebruikers</option>
                                    <option value='vervanger'>Vervangers</option>
                                    <option value='melder'>Melders</option>
                                    <option value='coordinator'>Coördinatoren</option>
                                </select>
                            </div>
                            <div>
                                <select className={`form-select select`} style={{ width: '175px' }} value={filterData.contractType} onChange={(e) => { filterHandler('contractType', e.target.value) }}>
                                    <option value={''}>Alle contracttypen</option>
                                    {contractList?.map(item => {
                                        return <option value={item.id}>{`${item.abbr} - ${item.name}`}</option>
                                    })}
                                </select>
                            </div>
                        </div>

                        <Button
                            outline
                            className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                            onClick={() => {
                                formikSubmit();
                            }}
                            disabled={btnDisabled}
                            type="button"
                            color="primary"
                        >
                            Versturen
                        </Button>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    )
}

export default SendSMS